export enum PublishProductsType {
  PRODUCT = 'PRODUCT',
  PRICING = 'PRICING',
}

export interface IPublishProductsRequestBody {
  publish_type: PublishProductsType[];
  category_ids?: string[];
  price_scheme_id?: string;
  instance_id?: string;
  venues?: string[];
  excluded_item_ids?: string[];
  publication_date_time?: string | undefined;
  schedule_name?: string;
}

export interface IPublishProductsResponse {
  event_id: string;
  schedule_ids: string[];
  schedule_name?: string;
}
